// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/cjs.js!../../../../shared/brand-variables.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/cjs.js!../../../../shared/responsive-variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import Brand Variables */

.topbar {
  height: var(--mobile-header-height);
  background: var(--color-surface);
  border-bottom: 1px solid var(--color-surface-dark);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--mobile-padding);
  flex-shrink: 0;
  box-shadow: var(--shadow-sm);
}

.topbar-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.topbar-menu-btn {
  display: none;
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  color: var(--color-text-primary);
  font-size: 24px;
  line-height: 1;
  min-width: var(--touch-target-min);
  min-height: var(--touch-target-min);
  align-items: center;
  justify-content: center;
  border-radius: var(--border-radius-md);
  transition: background 0.2s;
}

.topbar-menu-btn:hover {
  background: var(--color-surface-dark);
}

.topbar-menu-icon {
  display: block;
}

.topbar-heading {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
  margin: 0;
}

.topbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.topbar-user {
  position: relative;
}

.topbar-avatar-btn {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  background: none;
  border: 1px solid var(--color-surface-dark);
  border-radius: var(--border-radius-md);
  padding: 4px 12px 4px 4px;
  cursor: pointer;
  font-size: 14px;
  color: var(--color-text-primary);
  transition: all var(--transition-fast);
  min-height: var(--touch-target-min);
}

.topbar-avatar-btn:hover {
  background: var(--color-surface-dark);
  box-shadow: var(--shadow-sm);
}

.topbar-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--color-primary);
  color: var(--color-surface);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  flex-shrink: 0;
  box-shadow: var(--shadow-sm);
}

.topbar-username {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--color-text-primary);
}

.topbar-caret {
  font-size: 10px;
  color: var(--color-text-secondary);
}

.topbar-dropdown {
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  min-width: 200px;
  background: var(--color-surface-light);
  border: 1px solid var(--color-surface-dark);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-lg);
  z-index: var(--z-dropdown);
  overflow: hidden;
}

.topbar-dropdown-header {
  padding: 12px 16px;
}

.topbar-dropdown-email {
  font-size: 13px;
  font-weight: 500;
  color: var(--color-text-primary);
  word-break: break-word;
}

.topbar-dropdown-org {
  font-size: 12px;
  color: var(--color-text-secondary);
  margin-top: 2px;
}

.topbar-dropdown-divider {
  height: 1px;
  background: var(--color-surface-dark);
}

.topbar-dropdown-item {
  display: block;
  width: 100%;
  padding: 10px 16px;
  background: none;
  border: none;
  text-align: left;
  font-size: 13px;
  color: var(--color-text-primary);
  cursor: pointer;
  min-height: var(--touch-target-min);
  transition: background var(--transition-fast);
}

.topbar-dropdown-item:hover {
  background: var(--color-surface-dark);
}

.topbar-login-btn {
  padding: 8px 20px;
  background: #3b82f6;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
  min-height: var(--touch-target-min);
}

.topbar-login-btn:hover {
  background: #2563eb;
}

/* Mobile: Show hamburger menu */
@media (max-width: 767px) {
  .topbar {
    padding: 0 12px;
  }

  .topbar-menu-btn {
    display: flex;
  }

  .topbar-heading {
    font-size: 16px;
  }

  .topbar-username {
    display: none;
  }

  .topbar-caret {
    display: none;
  }

  .topbar-avatar-btn {
    padding: 4px;
  }
}

/* Tablet and up */
@media (min-width: 768px) {
  .topbar {
    padding: 0 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TopBar.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAI3B;EACE,mCAAmC;EACnC,gCAAgC;EAChC,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,kCAAkC;EAClC,mCAAmC;EACnC,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;EAC3C,sCAAsC;EACtC,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,gBAAgB;EAChB,sCAAsC;EACtC,2CAA2C;EAC3C,sCAAsC;EACtC,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Import Brand Variables */\n@import '../../../../shared/brand-variables.css';\n@import '../../../../shared/responsive-variables.css';\n\n.topbar {\n  height: var(--mobile-header-height);\n  background: var(--color-surface);\n  border-bottom: 1px solid var(--color-surface-dark);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 var(--mobile-padding);\n  flex-shrink: 0;\n  box-shadow: var(--shadow-sm);\n}\n\n.topbar-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.topbar-menu-btn {\n  display: none;\n  background: none;\n  border: none;\n  padding: 8px;\n  cursor: pointer;\n  color: var(--color-text-primary);\n  font-size: 24px;\n  line-height: 1;\n  min-width: var(--touch-target-min);\n  min-height: var(--touch-target-min);\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--border-radius-md);\n  transition: background 0.2s;\n}\n\n.topbar-menu-btn:hover {\n  background: var(--color-surface-dark);\n}\n\n.topbar-menu-icon {\n  display: block;\n}\n\n.topbar-heading {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  margin: 0;\n}\n\n.topbar-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.topbar-user {\n  position: relative;\n}\n\n.topbar-avatar-btn {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  background: none;\n  border: 1px solid var(--color-surface-dark);\n  border-radius: var(--border-radius-md);\n  padding: 4px 12px 4px 4px;\n  cursor: pointer;\n  font-size: 14px;\n  color: var(--color-text-primary);\n  transition: all var(--transition-fast);\n  min-height: var(--touch-target-min);\n}\n\n.topbar-avatar-btn:hover {\n  background: var(--color-surface-dark);\n  box-shadow: var(--shadow-sm);\n}\n\n.topbar-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: var(--color-primary);\n  color: var(--color-surface);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 14px;\n  flex-shrink: 0;\n  box-shadow: var(--shadow-sm);\n}\n\n.topbar-username {\n  max-width: 150px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--color-text-primary);\n}\n\n.topbar-caret {\n  font-size: 10px;\n  color: var(--color-text-secondary);\n}\n\n.topbar-dropdown {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 6px);\n  min-width: 200px;\n  background: var(--color-surface-light);\n  border: 1px solid var(--color-surface-dark);\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-lg);\n  z-index: var(--z-dropdown);\n  overflow: hidden;\n}\n\n.topbar-dropdown-header {\n  padding: 12px 16px;\n}\n\n.topbar-dropdown-email {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--color-text-primary);\n  word-break: break-word;\n}\n\n.topbar-dropdown-org {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  margin-top: 2px;\n}\n\n.topbar-dropdown-divider {\n  height: 1px;\n  background: var(--color-surface-dark);\n}\n\n.topbar-dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 10px 16px;\n  background: none;\n  border: none;\n  text-align: left;\n  font-size: 13px;\n  color: var(--color-text-primary);\n  cursor: pointer;\n  min-height: var(--touch-target-min);\n  transition: background var(--transition-fast);\n}\n\n.topbar-dropdown-item:hover {\n  background: var(--color-surface-dark);\n}\n\n.topbar-login-btn {\n  padding: 8px 20px;\n  background: #3b82f6;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s;\n  min-height: var(--touch-target-min);\n}\n\n.topbar-login-btn:hover {\n  background: #2563eb;\n}\n\n/* Mobile: Show hamburger menu */\n@media (max-width: 767px) {\n  .topbar {\n    padding: 0 12px;\n  }\n\n  .topbar-menu-btn {\n    display: flex;\n  }\n\n  .topbar-heading {\n    font-size: 16px;\n  }\n\n  .topbar-username {\n    display: none;\n  }\n\n  .topbar-caret {\n    display: none;\n  }\n\n  .topbar-avatar-btn {\n    padding: 4px;\n  }\n}\n\n/* Tablet and up */\n@media (min-width: 768px) {\n  .topbar {\n    padding: 0 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
